import React from 'react';
import { Shield, Heart, Clock, Award } from 'lucide-react';
import { motion } from 'framer-motion';
import { PageTransition } from '../components/PageTransition';
export function About() {
  return <PageTransition data-id="element-180">
      <div className="bg-white" data-id="element-181">
        {/* Page Header */}
        <div className="bg-brand-light py-20 lg:py-32" data-id="element-182">
          <div className="container mx-auto px-4 md:px-6 text-center" data-id="element-183">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-brand-blue mb-6 tracking-tight" data-id="element-184">
              About CareBridge
            </motion.h1>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed" data-id="element-185">
              Dedicated to providing safe, reliable, and compassionate
              non-emergency medical transportation for our community.
            </motion.p>
          </div>
        </div>

        {/* Mission Section */}
        <section className="py-20" data-id="element-186">
          <div className="container mx-auto px-4 md:px-6" data-id="element-187">
            <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-188">
              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6
            }} data-id="element-189">
                <h2 className="text-3xl md:text-4xl font-extrabold text-brand-blue mb-6" data-id="element-190">
                  Our Mission
                </h2>
                <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-191">
                  <p data-id="element-192">
                    At CareBridge, we are on a mission to redefine the Inter
                    Facility Transfer industry, offering our valued customers a
                    comprehensive continuum of care.
                  </p>
                  <p data-id="element-193">
                    We understand that medical transportation is more than just
                    getting from point A to point B. It's about ensuring the
                    dignity, comfort, and safety of every patient entrusted to
                    our care.
                  </p>
                  <p data-id="element-194">
                    Beyond merely providing transportation, we believe in
                    elevating the non-emergency medical transportation
                    experience to something more profound—a seamless extension
                    of the healthcare system.
                  </p>
                </div>
              </motion.div>
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="relative rounded-3xl overflow-hidden shadow-2xl aspect-[4/3]" data-id="element-195">
                <img src="https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&q=80&w=1200" alt="Medical professionals caring for a patient" className="w-full h-full object-cover" data-id="element-196" />
              </motion.div>
            </div>
          </div>
        </section>

        {/* Core Values */}
        <section className="py-20 bg-gray-50" data-id="element-197">
          <div className="container mx-auto px-4 md:px-6" data-id="element-198">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mb-16" data-id="element-199">
              <h2 className="text-3xl md:text-4xl font-extrabold text-brand-blue mb-6" data-id="element-200">
                Our Core Values
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-201">
                These principles guide every decision we make and every
                interaction we have with our patients and partners.
              </p>
            </motion.div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-202">
              {[{
              icon: Heart,
              title: 'Compassion',
              desc: 'Treating every patient like family with empathy and respect.'
            }, {
              icon: Shield,
              title: 'Safety First',
              desc: 'Rigorous training and vehicle maintenance to ensure secure transport.'
            }, {
              icon: Clock,
              title: 'Reliability',
              desc: 'Punctual service you can count on for critical appointments.'
            }, {
              icon: Award,
              title: 'Excellence',
              desc: 'Continuously improving our standards of care and service.'
            }].map((value, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1,
              duration: 0.5
            }} className="bg-white p-8 rounded-3xl shadow-sm border border-gray-100 text-center hover:shadow-xl transition-shadow" data-id="element-203">
                  <div className="w-16 h-16 bg-brand-light rounded-full flex items-center justify-center text-brand-blue mx-auto mb-6" data-id="element-204">
                    <value.icon size={32} data-id="element-205" />
                  </div>
                  <h3 className="text-xl font-bold text-brand-blue mb-4" data-id="element-206">
                    {value.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-207">{value.desc}</p>
                </motion.div>)}
            </div>
          </div>
        </section>
      </div>
    </PageTransition>;
}